
import React from "react";
import { ArrowRight, Star } from "lucide-react";
import GlucoseCurve from "./GlucoseCurve";
import VerifiedLabel from "./VerifiedLabel";

const TestimonialPreview: React.FC = () => {
  // Rating stars display
  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <Star
          key={i}
          size={16}
          className={i < rating ? "text-primary fill-primary" : "text-neutral-300"}
        />
      );
    }
    return stars;
  };

  return <div className="rounded-xl bg-white p-4 md:p-8 shadow-card border border-neutral-200 relative overflow-hidden">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8">
        <div className="w-full md:w-2/5 aspect-square md:aspect-auto">
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 h-full flex flex-col">
            <h3 className="text-xs text-neutral-500 font-semibold uppercase mb-2">Glucose Response</h3>
            <div className="flex-grow relative">
              <GlucoseCurve />
            </div>
          </div>
        </div>

        <div className="hidden md:flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center animate-pulse-slow">
            <ArrowRight size={24} className="text-primary" />
          </div>
        </div>

        <div className="w-full md:w-3/5">
          <div className="bg-white border border-neutral-200 rounded-lg p-4 shadow-sm">
            <div className="flex items-center justify-between mb-3">
              <div>
                <div className="font-medium">B.B</div>
                <div className="text-xs text-neutral-500">Verified Tester</div>
              </div>
              <div>
                <VerifiedLabel />
              </div>
            </div>

            <p className="text-neutral-700 mb-4">&quot;CGM + Tastermonial = Super Experience!
It was great to learn more about how my
body responded to particular foods,
exercise, etc. through the program
provided by Tastermonial. It is a great
experience, everyone should do it more
than once!&quot;</p>

            <div className="flex items-center justify-between border-t border-neutral-200 pt-3 text-sm">
              <div className="flex items-center gap-1">
                {renderStars(5)}
              </div>
              <div className="text-primary-600 font-medium">5.0 star rating</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TestimonialPreview;
